class FilterDrawerToggle extends HTMLElement {
  #observer;
  #buttonIntersecting = true;
  #footerElement = document.querySelector('footer');
  #footerInView = false;

  connectedCallback() {
    this.#initIntersectionObserver();
  }

  disconnectedCallback() {
    this.#observer?.disconnect();
  }

  /**
   * Update sticky state based on button intersection
   * @description Hides sticky state when the filter toggle hasn't been scrolled past + when footer is in view.
   */
  #updateStickyState() {
    const hasScrolledPastButton = this.getBoundingClientRect().bottom < 0;
    const shouldBeSticky =
      !this.#buttonIntersecting && hasScrolledPastButton && !this.#footerInView;
    this.classList.toggle('filter-drawer-toggle--is-sticky', shouldBeSticky);
  }

  /**
   * Initialize intersection observer for button and footer
   */
  #initIntersectionObserver() {
    this.#observer = new IntersectionObserver((entries) => {
      for (const entry of entries) {
        if (entry.target === this) this.#buttonIntersecting = entry.isIntersecting;
        if (entry.target === this.#footerElement) this.#footerInView = entry.isIntersecting;
      }

      this.#updateStickyState();
    });

    this.#observer.observe(this);
    if (this.#footerElement) this.#observer.observe(this.#footerElement);
  }
}

customElements.define('filter-drawer-toggle', FilterDrawerToggle);
